import { connect } from 'react-redux';

import BuildSelectorModalComponent from './../Components/BuildSelectorModalComponent.jsx';
import { modal as modalActions } from './../actions';
import {
  getModalInfoByOwner,
  getModalVisibility
} from './../reducers';
import { owners } from './../helpers/modals';

export const mapStateToProps = (state) => {
  return {
    visible: getModalVisibility(state, owners.buildsBaseline),
    isBaseline: getModalInfoByOwner(state, owners.buildsBaseline).isBaseline
  };
};

export default connect(
  mapStateToProps,
  { onHide: () => modalActions.showBuildSelectorModal(false) }
)(BuildSelectorModalComponent);


// WEBPACK FOOTER //
// src/Containers/BuildSelectorModalContainer.jsx